import { Component } from '@angular/core';
import { AgFilterComponent } from "ag-grid-angular";
import { IDoesFilterPassParams, IFilterParams } from "ag-grid-community";
import { CcfacRange } from '../models';
import { CcenterService } from '../services';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'org-id-filter-component',
    template: `
        <div class="p-1" *ngIf="ccfacRanges.length > 0">
            <div class="mb-2">
                <button type="button" class="btn btn-sm btn btn-primary btn-block" (click)="selectAll()">
                    <fa-icon [icon]="['fas', 'check-square']"></fa-icon> Select All
                </button>
                <button type="button" class="btn btn-sm btn btn-secondary btn-block" (click)="deselectAll()">
                    <fa-icon [icon]="['fas', 'square']"></fa-icon> Deselect All
                </button>
            </div>
            <div *ngFor="let ccfacRange of ccfacRanges">
                <div class="form-group form-check mb-0">
                    <input type="checkbox" class="form-check-input" id="{{ccfacRange.orgElementCode}}" [checked]="isChecked(ccfacRange.orgElementCode)" (change)="toggleOrgCodeSelection(ccfacRange)">
                    <label class="form-check-label" for="{{ccfacRange.orgElementCode}}">{{ccfacRange.orgElementCode}} - {{ccfacRange.description}}</label>
                </div>
            </div>
        </div>
   `
})
export class OrgCodeFilter implements AgFilterComponent {
    params: IFilterParams;
    ccfacRanges: CcfacRange[] = [];
    selectedCcfacRanges: CcfacRange[] = [];

    constructor(private readonly ccenterService: CcenterService, private readonly route: ActivatedRoute) {}

    agInit(params: IFilterParams): void {
        this.params = params;
        this.route.data.subscribe(({ ccfacRanges }: { ccfacRanges: CcfacRange[] }) => {
            this.ccfacRanges = this.removeDuplicateFilterOptions(ccfacRanges);
        });

        this.ccfacRanges.forEach((ccfacRange) => {
            this.selectedCcfacRanges.push(ccfacRange)
        });
    }

    
    isFilterActive(): boolean {
        return true;
    }

    doesFilterPass(params: IDoesFilterPassParams): boolean {
        return this.selectedCcfacRanges.map(m => m.orgElementCode).indexOf(params.data.orgElementCode) !== -1;
    }

    getModel() {
        if (!this.isFilterActive()) {
            return null;
        }
        
        if (this.selectedCcfacRanges.length == this.ccfacRanges.length) {
            return null;
        }

        return { value: this.selectedCcfacRanges };
    }

    setModel(model: any) {
    }

    isChecked(orgElementCode: string) {
        return this.selectedCcfacRanges.map(m => m.orgElementCode).indexOf(orgElementCode) !== -1
    }

    toggleOrgCodeSelection(ccfacRange: CcfacRange) {
        var index = this.selectedCcfacRanges.map(m => m.orgElementCode).indexOf(ccfacRange.orgElementCode);
        if (index === -1) {
            this.selectedCcfacRanges.push(ccfacRange);
        } else {
            this.selectedCcfacRanges.splice(index, 1);
        }
        this.params.filterChangedCallback();
    }

    selectAll() {
        this.selectedCcfacRanges = [];
        this.ccfacRanges.forEach((ccfacRange) => {
            this.selectedCcfacRanges.push(ccfacRange);
        });
        this.params.filterChangedCallback();
    }

    deselectAll() {
        this.selectedCcfacRanges = [];
        this.params.filterChangedCallback();
    }

    removeDuplicateFilterOptions(ccfacRanges: CcfacRange[]) {
        let ranges: CcfacRange[] = [];

        ccfacRanges.forEach((ccfacRange) => {
            if (!ranges.some(c => c.orgElementCode === ccfacRange.orgElementCode)) {
                ranges.push(ccfacRange);
            }
        });

        return ranges;
    }
}